import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import {closeRequest, getCities, getCourses, saveRequest} from "../../../../_actions/commonService";
import ButtonComponent from "../../../../_components/common/buttons/ButtonComponent";
import "./RequestPage.sass";
import TextFieldEdit from "../../../../_components/common/fields/TextFieldEdit";
import CloseIcon from "@mui/icons-material/Close";
import CircleButton from "../../../../_components/common/buttons/CircleButton";
import PhoneNumberTextEdit from "../../../../_components/common/fields/PhoneNumberTextEdit";
import SelectTextEdit from "../../../../_components/common/fields/SelectTextEdit";
import Window from "../../../../_containers/window/Window";
import Spinner from "../Spinner";
import {LOADING, SUCCESS} from "../../../../common/statuses";
import {COURSES} from "../../../../common/links";

export default function RequestPage() {
    const [request, setRequest] = useState({
        course: {
            id: undefined
        },
        email: undefined,
        fullName: undefined,
        phoneNumber: '',
        city: {
            id: 1
        }
    })

    const {data, status} = useSelector(state => state.common.courses)
    const {errors, status: requestStatus} = useSelector(state => state.common.request)
    const {data: cities, status: cityStatus} = useSelector(state => state.common.cities)
    const dispatch = useDispatch();
    const params = useParams();
    const id = parseInt(params.id)

    useEffect(() => {
        setRequest({
            ...request,
            course: {
                id: id
            }
        })
        if (cityStatus === 'idle') {
            dispatch(getCities())
        }
        if (status === 'idle') {
            dispatch(getCourses())
        }
    }, [status, cityStatus, requestStatus, dispatch]);

    if (!data || requestStatus === LOADING) {
        return <Spinner/>
    }

    const onCityChange = (e) => {
        setRequest({
            ...request,
            city: {
                id: e.target.value
            }
        })
    }

    const onPhoneNumberChange = (e) => {
        setRequest({
            ...request,
            phoneNumber: e.target.value
        })
    }

    const onTextChange = (e, field) => {
        setRequest({
            ...request,
            [field]: e.target.value
        })
    }

    const course = data.filter(item => item.id === id)[0]

    const renderFields = () => {
        return <>
            <TextFieldEdit label="Курс" disabled value={course.name}/>
            <TextFieldEdit label="Электронная почта"
                           error={errors && errors['email']}
                           helperText={errors && errors['email']}
                           value={request.email}
                           onChange={(e) => onTextChange(e, 'email')}
            />
            <TextFieldEdit label="Ваш ФИО"
                           error={errors && errors['fullName']}
                           helperText={errors && errors['fullName']}
                           value={request.fullName}
                           onChange={(e) => onTextChange(e, 'fullName')}
            />
            <PhoneNumberTextEdit label="Номер телефона"
                                 error={errors && errors['phoneNumber']}
                                 helperText={errors && errors['phoneNumber']}
                                 value={request.phoneNumber}
                                 onChange={onPhoneNumberChange}
            />
            <SelectTextEdit label="Город"
                            value={request.city.id}
                            data={cities && cities.map(city => {
                                return {
                                    value: city.id,
                                    name: city.name + (city.region ? `, ${city.region}` : '')
                                }
                            })}
                            onChange={onCityChange}
            />
        </>
    }

    return (
        <Window>
            <div className="request-header">
                <div className="request-header-text">
                    {requestStatus !== SUCCESS ? "Введите ваши данные" : "Заявка принята"}
                </div>
                <div className="request-header-close">
                    <CircleButton Icon={CloseIcon} link={COURSES} onClick={() => dispatch(closeRequest())}/>
                </div>
            </div>
            <div className="request-footer">
                {
                    requestStatus === "succeeded"
                        ? <div className="request-footer-success">Ваша заявка принята. <br/>С вами свяжутся в ближайшее
                            время.</div>
                        : renderFields()
                }
            </div>
            {
                requestStatus !== "succeeded" && <div className="request-bottom">
                    <ButtonComponent onClick={() => dispatch(saveRequest(request))}>Записаться</ButtonComponent>
                </div>
            }
        </Window>
    )
}